import React, { Component } from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import { StaticFluidImage } from "../../Components/StaticImage/";
import IntroSection from "../../Components/IntroSection";
import PartSection from "../../Components/PartSection";

class AboutUsPage extends Component {
  render() {
    return (
      <Wrapper>
        <div className="banner">
          <StaticFluidImage
            path="banner03.jpg"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }}
          />
          <h3>- ABOUT US -</h3>
        </div>
        <div className="container">
          <IntroSection />
          <PartSection />
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .banner {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    height: 600px;
    background-color: lightgray;

    & > h3 {
      position: absolute;
      z-index: 3;
      letter-spacing: 20px;
      font-size: 54px;
      color: white;
    }

    @media screen and (max-width: 650px) {
      & > h3 {
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    @media screen and (max-width: 550px) {
      height: 300px;
      & > h3 {
        letter-spacing: 5px;
        font-size: 26px;
      }
    }
  }

  & > .container {
    margin: 0 auto;
    padding: 10px;
    max-width: 720px;
    width: 100%;
  }
`;

export default withPage(AboutUsPage);
